import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import IconButton from '../common/IconButton.vue';
import { useBasicStore } from '../../../stores/basic';
import { storeToRefs } from 'pinia';
import { ICON_NAME } from '../../../constants/icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingControl',
  setup(__props) {

const basicStore = useBasicStore();
const { showSettingDialog } = storeToRefs(basicStore);

const iconName = computed(() => (showSettingDialog.value ? ICON_NAME.SettingActive : ICON_NAME.Setting));

function handleShowSettingDialog() {
  basicStore.setShowSettingDialog(!basicStore.showSettingDialog);
}

return { __sfc: true,basicStore, showSettingDialog, iconName, handleShowSettingDialog, IconButton }
}

})